import { CourseEntity } from '@/types/course';

export const CalculateFinalPrice = (course: CourseEntity) => {
  let finalPrice = course.price.value, priceWithDiscount;

  if (course.discount?.method === 'fixed') {
    priceWithDiscount = finalPrice - course.discount.value;
  } else if (course.discount?.method === 'percentage') {
    priceWithDiscount = finalPrice - (finalPrice * course.discount.value) / 100;
  }

  return {
    finalPrice,
    priceWithDiscount,
  }
}